import { UseQueryOptions, useQuery, keepPreviousData } from '@tanstack/vue-query';
import { Ref } from 'vue';
import { RecordResponse, RecordType } from '@/types';
import ApiRequest from '@/plugins/store/actions/api/ApiRequest';

export const queryKeys = {
    getRecordsRoot: ['records'],
    recordsWithParams: (params: Ref<RecordsFetchParams>) => [...queryKeys.getRecordsRoot, params],
    recordTypes: () => [...queryKeys.getRecordsRoot, 'recordTypes'],
};

export type RecordsFetchParams = {
    pageSize: number;
    page: number;
    typeIds: number[];
    period: string;
    siteIds: number[];
};

export function useRecords(fetchParams: Ref<RecordsFetchParams>, options: UseQueryOptions<RecordResponse> = {}) {
    return useQuery({
        queryKey: queryKeys.recordsWithParams(fetchParams),
        queryFn: () => {
            let params = `?page_size=${fetchParams.value.pageSize}&page_number=${fetchParams.value.page}`;

            if (fetchParams.value.typeIds?.length) {
                params += `&type_ids=${fetchParams.value.typeIds.join(',')}`;
            }

            if (fetchParams.value.period) {
                params += `&${fetchParams.value.period}`;
            }

            if (fetchParams.value.siteIds?.length) {
                params += `&site_ids=${fetchParams.value.siteIds.join(',')}`;
            }

            return new ApiRequest().send('get', `records${params}`, {
                skipLoadingIndicator: true,
                skipCache: true,
            });
        },
        placeholderData: keepPreviousData,
        ...options,
    });
}

export function useRecordTypes(options: UseQueryOptions<RecordType[]> = {}) {
    return useQuery<RecordType[]>({
        queryKey: queryKeys.recordTypes(),
        queryFn: () => new ApiRequest().send('get', 'definitions/record-types'),
        ...options,
    });
}
